<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'bestof_dsrobjectives.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <grid-filters grid-data="besfofDsrObjetivesGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="besfofDsrObjetivesGrid" name="besfofDsrObjetivesGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'besfofDsrObjetivesGrid',
  components: {
    Grid
  },
  data() {
    return {
      filters: {
        dsr: null,
        dsr_id: null
      },
      gridFilters: [{
        field:'campaign_id',
        modal:'bestof-modal',
        foreign: 'id',
        placeholder: 'Campanha'
      }, {
        field:'dsr_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'DSR'
      }, {
        field:'zone',
        modal:'zones-modal',
        foreign: 'zone',
        placeholder: 'Zona'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dsr_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'dsr/lst/dsr',
        field: 'dsr_id'
      }, {
        api: 'bestof/campaigns/lst',
        field: 'campaign_id'
      }],
      url: 'bestof/dsrobjectives',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'campaign_id',
        title: 'Campanha',
        width: '220px'
      },
      {
        field: 'dsr_id',
        title: 'DSR',
        width: '220px'
      },
      {
        field: 'zone',
        title: 'Zona',
        width: '120px'
      },
      {
        field: 'value',
        title: 'Valor',
        width: '120px'
      },
      {
        field: 'operators',
        title: 'Operadores',
        width: '120px'
      },
      {
        field: 'quantity',
        title: 'Quantidade',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    selectDsr(e) {
      if(e.item) {
        this.filters.dsr_id = e.item.id
        this.filters.dsr = e.item
        this.$refs.besfofDsrObjetivesGrid.applyFilter('dsr_id', this.filters.dsr_id)
      } else {
        this.filters.dsr_id = null
        this.filters.dsr = null
        this.$refs.besfofDsrObjetivesGrid.removeFilter('dsr_id')
      }
    },
    selectZone(e) {
      if(e.item) {
        this.filters.zone_id = e.item.id
        this.filters.zone = e.item
        this.$refs.besfofDsrObjetivesGrid.applyFilter('zone', this.filters.zone.zone)
      } else {
        this.filters.zone_id = null
        this.filters.zone = null
        this.$refs.besfofDsrObjetivesGrid.removeFilter('zone')
      }
    },
    selectBestof(e) {
      if(e.item) {
        this.filters.campaign_id = e.item.id
        this.filters.campaign = e.item
        this.$refs.besfofDsrObjetivesGrid.applyFilter('campaign_id', this.filters.campaign_id)
      } else {
        this.filters.campaign_id = null
        this.filters.campaign = null
        this.$refs.besfofDsrObjetivesGrid.removeFilter('campaign_id')
      }
    },
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'bestof_dsrobjectives.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('bestof_dsrobjectives.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
